import PropTypes from "prop-types";
import { useCallback } from "react";
import { RightArrow } from "../../resources/svg_components";
export default function P2BreadcrumbItem({ isLastItem, navigate, page, reverseIndex, action }) {
  const colorVariant = isLastItem ? "gray" : "green"; // The color for the link
  const disableClick = isLastItem ? "polymer-breadcrumb__disabled" : ""; // Disable link if the it is the last page
  const handleBreadcrumbItemClick = useCallback(() => {
    if(page?.action){
      page.action();
    }else{
      window.location.href = page.link;
    }
  }, [page])
  return (
    <>
        {page.link ? (
          <div onClick={handleBreadcrumbItemClick} className={`polymer-breadcrumb__title polymer-breadcrumb__title-${colorVariant} ${disableClick}`}>
            {page.title}
          </div>
        ) : (
          <button
            className={`polymer-breadcrumb__title polymer-breadcrumb__title-${colorVariant} ${disableClick}`}
            onClick={
              isLastItem
                ? null
                : () => {
                    navigate(reverseIndex);
                  }
            }
          >
            {page.title}
          </button>
        )}
      {!isLastItem && <RightArrow key={page.title} strokeColor="#575757"/>}
    </>
  );
}

P2BreadcrumbItem.propType = {
  isLastItem: PropTypes.bool.isRequired,
  navigate: PropTypes.func,
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    action: PropTypes.func
  }),
  reverseIndex: PropTypes.number,
};
